export const CheckIcon = ({ fill='none', width='20', height='20', className='' }) => {
  return (
    
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.428571" y="0.428571" width="23.1429" height="23.1429" rx="11.5714" fill="white"/>
<rect x="0.428571" y="0.428571" width="23.1429" height="23.1429" rx="11.5714" stroke="#1A56DB" stroke-width="0.857143"/>
<path d="M10.2498 14.2483L16.3034 8.19475C16.4462 8.0519 16.6159 7.98047 16.8123 7.98047C17.0087 7.98047 17.1784 8.0519 17.3212 8.19475C17.4641 8.33761 17.5355 8.50725 17.5355 8.70368C17.5355 8.90011 17.4641 9.06975 17.3212 9.21261L10.7498 15.784C10.6069 15.9269 10.4403 15.9983 10.2498 15.9983C10.0593 15.9983 9.89266 15.9269 9.7498 15.784L6.67837 12.7126C6.53551 12.5698 6.46706 12.4001 6.47301 12.2037C6.47897 12.0073 6.55337 11.8376 6.69623 11.6948C6.83908 11.5519 7.00873 11.4805 7.20516 11.4805C7.40158 11.4805 7.57123 11.5519 7.71408 11.6948L10.2498 14.2483Z" fill="#1A56DB"/>
</svg>
    );
};

export default CheckIcon;
